<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <apexchart ref="apex" type="line" :height="height" :options="lineOptions" :series="series" />
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'
    import { captureWithLegend, COLORS } from './chartExportUtils'

    export default {
        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'categories'],

        data() {
            const cats = this.categories || []

            return {
                lineOptions: {
                    chart: {
                        type: 'line',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    title: {
                        text: ''
                    },
                    legend: {
                        show: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 2,
                        colors: ['#90A4AE']
                    },
                    xaxis: {
                        categories: cats,
                        labels: {
                            labels: cats,
                            show: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            const labels = w.config.xaxis.labels.labels
                            if (seriesIndex !== 1 && labels && labels.length > dataPointIndex) {
                                const label = labels[dataPointIndex]
                                const value = series[seriesIndex][dataPointIndex]
                                const color = COLORS[dataPointIndex % COLORS.length]
                                return '<div style="padding:5px;font-weight:bold;color:white;background-color:' + color + ';">' + label + ': ' + value + '</div>'
                            }
                            return ''
                        }.bind(this)
                    },
                    markers: {
                        size: 6,
                        discrete: cats.map((cat, i) => ({
                            seriesIndex: 0,
                            dataPointIndex: i,
                            fillColor: COLORS[i % COLORS.length],
                            strokeColor: COLORS[i % COLORS.length],
                            size: 6
                        }))
                    },
                    colors: ['#90A4AE'],
                    fill: {
                        type: 'solid',
                        colors: ['#90A4AE'],
                        opacity: 1
                    },
                }
            }
        },

        methods: {
            async capture() {
                try {
                    return await captureWithLegend(this.$refs.apex, this.categories || [])
                } catch (e) {
                    console.error('Line capture failed', e)
                    return null
                }
            }
        }
    }
</script>

<style>
    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }
</style>
